import React, { useEffect, useState } from "react";
import Header from "../headers/Header";
import MiddleContent from "../page/MiddleContent";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchCurrentUser, setUser } from "../../redux/userSlice";
import api from "../utils/api";
import { Spinner, Toast, ToastContainer } from "react-bootstrap";
import Cookies from "js-cookie";

export const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({
    show: false,
    reason: "",
    variant: "success",
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    const reason = queryParams.get("reason");

    if (reason === "google-oauth" && token) {
      setLoading(true);

      // Save token to Cookies first so api.js can use it
      Cookies.set("token", token, { expires: 1 });

      // Use the global action to fetch user details
      dispatch(fetchCurrentUser())
        .unwrap()
        .then(() => {
          setToast({
            show: true,
            message: "Google Login Successful! 🎉",
            variant: "success",
          });

          // Remove query params and redirect to home after a short delay
          setTimeout(() => {
            setLoading(false);
            navigate("/");
          }, 1500);
        })
        .catch((error) => {
          console.error("Google Login Error:", error);
          setLoading(false);
          navigate("/error?reason=google-oauth");
        });
    }
  }, [location, dispatch, navigate]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center vh-100"
        style={{ backgroundColor: "#000", color: "#fff" }}
      >
        <div className="text-center">
          <Spinner
            animation="border"
            variant="warning"
            style={{ width: "3rem", height: "3rem" }}
          />
          <h4 className="mt-3">Verifying Google Login...</h4>
        </div>
      </div>
    );
  }

  return (
    <>
      <ToastContainer
        position="top-end"
        className="p-3"
        style={{ zIndex: 9999 }}
      >
        <Toast
          bg={toast.variant}
          show={toast.show}
          delay={3000}
          autohide
          onClose={() => setToast({ ...toast, show: false })}
        >
          <Toast.Body className="text-white fw-bold">
            {toast.message}
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <MiddleContent />
    </>
  );
};
